import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/img/code-scanner.svg';
const _withScopeId = n => (_pushScopeId("data-v-4491b07e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "bottonBarDiv yihang3"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  style: {
    "width": "28px"
  }
}, null, -1));
const _hoisted_3 = ["fill"];
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M8 9C5.33 9 0 10.34 0 13V16H16V13C16 10.34 10.67 9 8 9ZM8 0C5.79 0 4 1.79 4 4C4 6.21 5.79 8 8 8C10.21 8 12 6.21 12 4C12 1.79 10.21 0 8 0ZM8 10.9C10.97 10.9 14.1 12.36 14.1 13V14.1H1.9V13C1.9 12.36 5.03 10.9 8 10.9ZM8 1.9C9.16 1.9 10.1 2.84 10.1 4C10.1 5.16 9.16 6.1 8 6.1C6.84 6.1 5.9 5.16 5.9 4C5.9 2.84 6.84 1.9 8 1.9Z"
}, null, -1));
const _hoisted_5 = [_hoisted_4];
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "grayzisty"
}, "Profile", -1));
import { ref, onActivated, computed } from "vue";
import router from "../router";
import { useStore } from "vuex";
export default {
  __name: 'bottonBar',
  setup(__props) {
    const store = useStore();
    const msg = ref('jacson');
    const TBactive = ref(store.state.bottomBarNum);
    // console.log(store.state.bottomBarNum);

    //主题颜色
    const colorwhich = computed(() => {
      const barindx = store.state.bottomBarNum;
      var homecolor = "var(--theme-bottomBar-color)";
      var qrcolor = "var(--theme-bottomBar-color)";
      var mycolor = "var(--theme-bottomBar-color)";
      if (barindx == 0) {
        homecolor = '#EC6189';
      } else if (barindx == 1) {} else if (barindx == 2) {
        mycolor = '#EC6189';
      }
      return {
        homecolor,
        mycolor
      };
    });
    const acBarNum = computed(() => {
      return store.state.bottomBarNum;
    });
    const changepage = num => {
      // console.log(num,store.state.bottomBarNum);

      if (num == 0) {
        store.commit('changecamara', 'off');
        let homeurl = sessionStorage.getItem("homePageUrlSesson");
        if (homeurl) {
          router.push(homeurl);
        } else {
          router.push('/allMerchantList');
        }
        store.commit('sweichTab', 0);
      } else if (num == 1) {
        store.commit('changecamara', 'auto');
        router.push('/qrReader');
        store.commit('sweichTab', 1);
      } else if (num == 2) {
        store.commit('changecamara', 'off');
        var hasloginma = localStorage.getItem('hasLogin');
        console.log('是否登录', hasloginma);
        router.push('/myProfile');
        store.commit('sweichTab', 2);
      }
    };
    onActivated(() => {
      msg;
      TBactive;
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = $event => changepage(1)),
        class: "sandenfen"
      }, [_hoisted_2, _createElementVNode("div", {
        class: "grayzisty",
        style: _normalizeStyle({
          color: acBarNum.value == 1 ? '#000' : ''
        })
      }, "Scan", 4)]), _createElementVNode("div", {
        onClick: _cache[1] || (_cache[1] = $event => changepage(2)),
        class: "sandenfen"
      }, [(_openBlock(), _createElementBlock("svg", {
        width: "26",
        height: "26",
        viewBox: "0 -2 19 19",
        fill: colorwhich.value.mycolor,
        xmlns: "http://www.w3.org/2000/svg"
      }, _hoisted_5, 8, _hoisted_3)), _hoisted_6])]);
    };
  }
};